// extracted by mini-css-extract-plugin
export default {"progress":"_1amhKmitaCuv-5x5Gz9wBQ","msWaitingProgress":"_19WPWoiABQNE3VQEVL1C2N","progressBar":"LlIDlBNOkjJAqvfKxb2qA","msWaitingProgressBar":"_1cRJI_pVV-y7a_O-t92uF2"};